export const ordersData = [
  {
    id: 'ORD-001',
    customer: {
      name: 'Rajesh Kumar',
      email: 'rajesh.kumar@gmail.com',
      phone: '+91 98765 43210',
      address: '123 MG Road, Bangalore, Karnataka 560001'
    },
    date: '2024-01-15',
    time: '10:30 AM',
    amount: 107817, // ₹1,07,817
    status: 'Completed',
    products: [
      { name: 'Samsung Galaxy S24 Ultra', quantity: 1, price: 107817, image: 'https://images.unsplash.com/photo-1592750475338-74b7b21085ab?w=50&h=50&fit=crop' }
    ]
  },
  {
    id: 'ORD-002',
    customer: {
      name: 'Priya Sharma',
      email: 'priya.sharma@gmail.com',
      phone: '+91 87654 32109',
      address: '456 CP Road, Mumbai, Maharashtra 400001'
    },
    date: '2024-01-14',
    time: '2:15 PM',
    amount: 110666, // ₹1,10,666
    status: 'Pending',
    products: [
      { name: 'OnePlus 12 Pro', quantity: 1, price: 89999, image: 'https://images.unsplash.com/photo-1541807084-5c52b6b3adef?w=50&h=50&fit=crop' },
      { name: 'OnePlus Buds Pro 2', quantity: 1, price: 20667, image: 'https://images.unsplash.com/photo-1583394838336-acd977736f90?w=50&h=50&fit=crop' }
    ]
  },
  {
    id: 'ORD-003',
    customer: {
      name: 'Amit Patel',
      email: 'amit.patel@gmail.com',
      phone: '+91 76543 21098',
      address: '789 SG Highway, Ahmedabad, Gujarat 380001'
    },
    date: '2024-01-14',
    time: '11:45 AM',
    amount: 49717, // ₹49,717
    status: 'Completed',
    products: [
      { name: 'Realme GT 6 Pro', quantity: 1, price: 49717, image: 'https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?w=50&h=50&fit=crop' }
    ]
  },
  {
    id: 'ORD-004',
    customer: {
      name: 'Sneha Gupta',
      email: 'sneha.gupta@gmail.com',
      phone: '+91 65432 10987',
      address: '321 Sector 18, Noida, Uttar Pradesh 201301'
    },
    date: '2024-01-13',
    time: '4:20 PM',
    amount: 65999, // ₹65,999
    status: 'Completed',
    products: [
      { name: 'Xiaomi 14 Pro', quantity: 1, price: 65999, image: 'https://images.unsplash.com/photo-1583394838336-acd977736f90?w=50&h=50&fit=crop' }
    ]
  },
  {
    id: 'ORD-005',
    customer: {
      name: 'Vikram Singh',
      email: 'vikram.singh@gmail.com',
      phone: '+91 54321 09876',
      address: '654 Civil Lines, Delhi, Delhi 110001'
    },
    date: '2024-01-13',
    time: '9:10 AM',
    amount: 41999, // ₹41,999
    status: 'Canceled',
    products: [
      { name: 'Vivo V30 Pro', quantity: 1, price: 41999, image: 'https://images.unsplash.com/photo-1434493789847-2f02dc6ca35d?w=50&h=50&fit=crop' }
    ]
  },
  {
    id: 'ORD-006',
    customer: {
      name: 'Kavya Reddy',
      email: 'kavya.reddy@gmail.com',
      phone: '+91 43210 98765',
      address: '987 Banjara Hills, Hyderabad, Telangana 500001'
    },
    date: '2024-01-12',
    time: '3:30 PM',
    amount: 25999, // ₹25,999
    status: 'Pending',
    products: [
      { name: 'Nothing Phone 2a', quantity: 1, price: 25999, image: 'https://images.unsplash.com/photo-1541807084-5c52b6b3adef?w=50&h=50&fit=crop' }
    ]
  },
  {
    id: 'ORD-007',
    customer: {
      name: 'Arjun Mehta',
      email: 'arjun.mehta@gmail.com',
      phone: '+91 32109 87654',
      address: '147 Park Street, Kolkata, West Bengal 700001'
    },
    date: '2024-01-12',
    time: '1:15 PM',
    amount: 68998, // ₹68,998
    status: 'Completed',
    products: [
      { name: 'Samsung Galaxy A55', quantity: 1, price: 39999, image: 'https://images.unsplash.com/photo-1592750475338-74b7b21085ab?w=50&h=50&fit=crop' },
      { name: 'Samsung Galaxy Buds2 Pro', quantity: 1, price: 28999, image: 'https://images.unsplash.com/photo-1583394838336-acd977736f90?w=50&h=50&fit=crop' }
    ]
  },
  {
    id: 'ORD-008',
    customer: {
      name: 'Ananya Joshi',
      email: 'ananya.joshi@gmail.com',
      phone: '+91 21098 76543',
      address: '258 FC Road, Pune, Maharashtra 411001'
    },
    date: '2024-01-11',
    time: '5:45 PM',
    amount: 29999, // ₹29,999
    status: 'Completed',
    products: [
      { name: 'OnePlus Nord 4', quantity: 1, price: 29999, image: 'https://images.unsplash.com/photo-1541807084-5c52b6b3adef?w=50&h=50&fit=crop' }
    ]
  }
];

export const orderStatuses = ['Pending', 'Completed', 'Canceled'];